import gql from 'graphql-tag';

export default gql`
mutation updateUserLogin(
  $userId: Int!,
  $loggedInAt: timestamptz!
) {
  update_users(
    where: {user_id: {_eq: $userId}},
    _set: {last_login: $loggedInAt},
    _inc: {login_count: 1}
  ) {
    affected_rows
  }
}
`;
